/* The handwritten face, on or off.
 *
 * One attribute on <html> — `data-hand="on"` — because the design tokens live
 * on :root and every screen reads them from there. Nothing has to be passed
 * down, no page has to know, and turning it on changes the whole app in the
 * same frame.
 *
 * Persisted through the chassis `prefs` proxy, which is localStorage with the
 * reads and writes already handled. It is a per-device preference about how
 * this person likes to read, not part of the recipe, so it deliberately does
 * NOT live in the recipe store: turning it on must never look like an edit to
 * what she wrote.
 */
import { ref } from 'vue';
import { prefs } from '../core/storage.js';

const KEY = 'handwriting';

/** Whether the hand is on. Read it, or bind a toggle straight to it. */
export const handwriting = ref(prefs[KEY] === true);

function paint(on) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (on) root.setAttribute('data-hand', 'on');
  else root.removeAttribute('data-hand');
}

/** Flip it, remember it, and repaint. */
export function setHandwriting(on) {
  const next = Boolean(on);
  handwriting.value = next;
  prefs[KEY] = next;
  paint(next);
}

/* Called once at boot, before first paint, so a person who turned it on last
   week does not watch the app render in the serif and then swap under them. */
export function applyHandwriting() {
  paint(handwriting.value);
}

applyHandwriting();
